import { useRef, useState } from "react";
import { createContext, useContext, useMemo } from "react";
const HelpContext = createContext();

export const HelpProvider = ({ children }) => {
  const help_ = useRef(null);
  const [help, setHelp] = useState(false)


  const enableHelp = (v) => {
    help_.current = v
    setHelp(v)

    // console.log("set help to " + v)
  };
  const toggleHelp = () => {
    enableHelp(!help_.current)
  };

  const getHelp = (v) => {
    return help_.current
  };


  const value = useMemo(
    () => ({
      enableHelp,
      toggleHelp,
      getHelp,
      help_,
      help
    }),
    [help_, help]
  );
  return (
    <HelpContext.Provider value={value}>{children}</HelpContext.Provider>
  );
};

export const useHelp = () => {
  return useContext(HelpContext);
};
